import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service }) {
  return (
    <Link
      to={`/services/${service.slug}`}
      className="group relative block aspect-[4/5] overflow-hidden rounded-xl border border-slate-200/40 bg-slate-900"
      data-testid={`service-card-${service.slug}`}
    >
      <img
        src={service.image}
        alt={service.title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-60 transition-all duration-700 group-hover:scale-105 group-hover:opacity-75"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/60 to-slate-950/10" />
      <div className="relative flex h-full flex-col justify-end p-6 text-white">
        <h3 className="font-display text-2xl font-extrabold leading-tight tracking-tight">
          {service.title}
        </h3>
        <div className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-white/90 transition-colors group-hover:text-yellow-300">
          View Details
          <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
}
